import { render, staticRenderFns } from "./QuizMatchSection.vue?vue&type=template&id=72d284f1&scoped=true&"
import script from "./QuizMatchSection.vue?vue&type=script&lang=js&"
export * from "./QuizMatchSection.vue?vue&type=script&lang=js&"
import style0 from "./QuizMatchSection.vue?vue&type=style&index=0&id=72d284f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d284f1",
  null
  
)

export default component.exports